import ActionTypes from '../../actionTypes'
const { GET_ALL_DATA_FAIL, GET_ALL_DATA_SUCCESS } = ActionTypes.REPORTS.KM_DAILY

const initialState = {
  allKmDaily: [],
  dataCount: 0,
}

const kmDailyReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        allKmDaily: payload.rows,
        dataCount: payload.count,
      }
    case GET_ALL_DATA_FAIL:
      return {
        ...state,
        allKmDaily: [],
        dataCount: 0,
      }
    default:
      return state
  }
}

export default kmDailyReducer
